import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

type SnackbarColor = 'success' | 'error' | 'warning' | 'info'
type SnackbarType = 'success' | 'error' | 'warning' | 'info'

export const useSnackbarStore = defineStore('snackbar', () => {
  const show = ref<boolean>(false)
  const message = ref<string>('')
  const color = ref<SnackbarColor>('info')
  const timeout = ref<number>(4000)
  const type = ref<SnackbarType>('info')

  const isVisible = computed(() => show.value)

  const showSnackbar = (msg: string, msgColor: SnackbarColor = 'info', msgTimeout: number = 4000): void => {
    message.value = msg
    color.value = msgColor
    type.value = msgColor
    timeout.value = msgTimeout
    show.value = true
  }

  const hide = (): void => {
    show.value = false
  }

  const success = (msg: string, msgTimeout: number = 4000): void => {
    showSnackbar(msg, 'success', msgTimeout)
  }

  const error = (msg: string, msgTimeout: number = 6000): void => {
    showSnackbar(msg, 'error', msgTimeout)
  }

  const warning = (msg: string, msgTimeout: number = 5000): void => {
    showSnackbar(msg, 'warning', msgTimeout)
  }

  const info = (msg: string, msgTimeout: number = 4000): void => {
    showSnackbar(msg, 'info', msgTimeout)
  }

  return {
    show,
    message,
    color,
    timeout,
    type,
    isVisible,
    showMessage: showSnackbar,
    hide,
    success,
    error,
    warning,
    info
  }
})
